import { render } from "./official.vue?vue&type=template&id=fff5f3cc&scoped=true"
import script from "./official.vue?vue&type=script&lang=js"
export * from "./official.vue?vue&type=script&lang=js"

import "./official.vue?vue&type=style&index=0&id=fff5f3cc&scoped=true&lang=css"

import exportComponent from "D:\\yiban\\WebProject\\yiban-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fff5f3cc"]])

export default __exports__